<template>
  <div v-if="isLoading">Loading</div>
  <div v-else>
    <Table>
      <template v-if="workspaceInvitations.length">
        <TableHeader>
          <TableRow class="border-[#4C4C4C]">
            <TableHead>Workspace</TableHead>
            <TableHead class="text-right" />
          </TableRow>
        </TableHeader>
        <TableBody>
          <InvitationRow
            v-for="pi in workspaceInvitations"
            :id="pi.id"
            :key="pi.id"
            :name="pi.workspace.name"
            :is-expired="pi.is_expired"
          />
        </TableBody>
      </template>
      <template v-if="projectInvitations.length">
        <TableHeader>
          <TableRow class="border-[#4C4C4C]">
            <TableHead>Project</TableHead>
            <TableHead class="text-right" />
          </TableRow>
        </TableHeader>
        <TableBody>
          <InvitationRow
            v-for="pi in projectInvitations"
            :id="pi.id"
            :key="pi.id"
            :name="pi.project.name"
            :is-expired="pi.is_expired"
          />
        </TableBody>
      </template>
    </Table>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@ui/components/table';

import requests from '@vuex/requests.js';
import InvitationRow from './components/InvitationRow.vue';

const { isLoading, data: pendingInvitations } = useQuery({
  queryKey: ['pendingInvitations'],
  queryFn: () => requests.me.pendingInvitations(),
});

const workspaceInvitations = computed(() => {
  return (
    pendingInvitations.value?.filter(invitation => !invitation.project_id) ?? []
  );
});

const projectInvitations = computed(() => {
  return (
    pendingInvitations.value?.filter(
      invitation => invitation.project_id !== null
    ) ?? []
  );
});

console.log(pendingInvitations);
</script>
